import { useNavigate } from "react-router-dom";


export default function CustomerTable() {
    const navigate = useNavigate();

    const handleNavigate = (invoiceno) => {
        navigate(`/${invoiceno}`);
    };

    const data = [
        { id: 1, name: "John Snow",invoiceno:"1111", grade: "Grade A", division: "A" },
        { id: 2, name: "Net Stark",invoiceno:"1111", grade: "Graade B", division: "A" },
        { id: 3, name: "Night Walkar",invoiceno:"1111", grade: "Grade A", division: "B" },
        { id: 4, name: "Tyren Swift",invoiceno:"1111", grade: "Grade C", division: "B" },
        { id: 5, name: "Jimmy Toty",invoiceno:"1111", grade: "Grade A", division: "C" },
        { id: 6, name: "Agone Lyannister",invoiceno:"1111", grade: "Grade A", division: "C" },
    ];



    return (
        <div className="customer-container my-4">
            <div className="special-header panel-white-all  ">
                <h4 className="page-title mt-1">Customer</h4>
            </div>

            
<div className="table-top-filters d-flex flex-wrap gap-3">
                <input type="text" className="form-control form-control-sm gap-2" placeholder="Sudent Name"  style={{ maxWidth: "200px" }}/>

                <input type="text" className="form-control form-control-sm" placeholder="Student Division" style={{ maxWidth: "200px" }} />

                <button type="button" class="btn custom-btn">Clear</button>

            </div>

            <div className="card ">

                <div className="card-body p-0">



                    <div className="table-responsive">

                       

                        <table className="custom-table">
                            <thead>

                                <tr>
                                    <th>Sr No</th>
                                    <th>Student Name</th>
                                    <th>Grade</th>
                                    <th>Division</th>
                                    <th>Action</th>

                                </tr>
                                <tr>

                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.id}</td>
                                        <td>{row.name}</td>
                                        <td>{row.grade}</td>
                                        <td>{row.division}</td>


                                        <div className="btn-group mb-2">
                                            <button
                                                type="button"
                                                className="btn"
                                                onClick={() => handleNavigate(row.invoiceno)}
                                                title="View"
                                            >
                                                <i class="bi bi-eye"></i>
                                            </button>
                                        </div>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
